// extracted by mini-css-extract-plugin
module.exports = {"eventsIsland":"AnalyticsEvents_eventsIsland__nwhef","eventsIslandHeading":"AnalyticsEvents_eventsIslandHeading__3uDUm"};